import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const authTabsList = style([
  {
    marginTop: space.s20,
    gap: 0,
  },
]);

export const authTabItem = style([
  typography.bodyLg,
  {
    flexBasis: '50%',
    justifyContent: 'center',
    padding: space.s20,
  },
]);
